import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import FloatingContactButton from './FloatingContactButton';
import MessengerWidget from './MessengerWidget';
import PromoBanner from './PromoBanner';
import PromoPopup from './PromoPopup';
import { GoogleAnalytics } from './GoogleAnalytics';
import { FacebookPixel } from './FacebookPixel';
import CookieConsentBanner from './CookieConsentBanner';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Analytics - track page views automatically */}
      <GoogleAnalytics />
      <FacebookPixel />
      {/* Promotional banner (managed in Admin → Promos) */}
      <PromoBanner />
      {/* Promotional popup (managed in Admin → Promos) */}
      <PromoPopup />
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      {/* Floating contact: primary = site form; Messenger = optional Meta chat */}
      <FloatingContactButton />
      <MessengerWidget />
      <CookieConsentBanner />
    </div>
  );
}

